<template>
    <div name="sensitive">
        <h2>[민감정보의 수집 및 이용동의]</h2>
        <span>솔닥 주식회사(이하 "회사")는 솔닥 희귀난치성 질환자 대상 서비스 제공과 관련하여 개인정보보호법 제23조 제1항 제1호에 근거하여 아래와 같이 이용자의 민감정보를 수집 및 이용합니다.<br></span><br>
        <table class="table" border="1">
            <thead>
                <th style="width: 10%;">
                    구분
                </th>
                <th style="width: 30%;">
                    수집 및 이용 목적
                </th>
                <th style="width: 30%;">
                    수집 항목
                </th>
                <th style="width: 30%;">
                    보유 기간
                </th>
            </thead>
            <tbody>
                <tr>
                    <td>희귀난치성 질환자 대상 서비스 이용 자격 확인</td>
                    <td>고객 위임에 따른 솔닥 제휴 의료기관을 통한 희귀난치성 질환자 서비스 이용 자격 확인 대행</td>
                    <td>서비스 이용 자격 확인 결과(희귀난치성 질환 유무)</td>
                    <td>서비스 이용계약 종료 시 또는 회원 탈퇴 시까지</td>
                </tr>
            </tbody>
            
        </table>
        <span><br>※ 이용자는 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다. 다만 동의 거부 시 해당 서비스를 이용하실 수 없습니다.</span>
    </div>
</template>

<script>
export default {
    name: 'sensitive'
}
</script>

<style scoped>
    th {
      background-color: #f4f4f4;
      font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/pages/barocare/RareSensitive.vue